import { TextInputField } from './TextInputField';
import type { FormFieldComponent } from './types';
import { fieldRule, readFormField } from './useFormField';

const ROLE = 'genericInputField';
const FALLBACK_NAME = 'textAreaFormField';

const GenericFormTextAreaInputField: FormFieldComponent = () => (
  <TextInputField role={ROLE} fallbackName={FALLBACK_NAME} type="text" multiline={true} />
);

GenericFormTextAreaInputField.formSchema = content => fieldRule(readFormField(content, 'genericFields', ROLE), FALLBACK_NAME);

export default GenericFormTextAreaInputField;
